import PropTypes from "prop-types";
import React from "react";
import ToolTip2 from "./tooltip-2";
import PlainButton from "../elements/plain-button";
import uuid from "uuid/v4";

const ButtonTooltip = ({
  contentWidth = "auto",
  trigger,
  children,
  onTriggerClick,
  triggerClassName,
  triggerStyles,
  ...rest
}) => {
  // useRef so it only runs once
  // makes screen reader will associate tooltip button w/ content and read it
  const described_by = React.useRef("tooltip-" + uuid());
  return (
    <ToolTip2
      contentWidth={contentWidth}
      trigger={
        <PlainButton
          style={triggerStyles}
          onClick={onTriggerClick}
          className={triggerClassName}
          onKeyDown={e => {
            if (e.key === "Enter") onTriggerClick();
          }}
        >
          {trigger}
        </PlainButton>
      }
      {...rest}
    >
      <div id={described_by.current}>{children}</div>
    </ToolTip2>
  );
};

ButtonTooltip.propTypes = {
  contentWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  trigger: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  children: PropTypes.any,
  onTriggerClick: PropTypes.func,
  triggerClassName: PropTypes.string,
  triggerStyles: PropTypes.object,
};
export default ButtonTooltip;
